var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C11.9853 12 14 9.76142 14 7C14 4.23858 11.9853 2 9.5 2C7.01472 2 5 4.23858 5 7C5 9.76142 7.01472 12 9.5 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.4516C13.0624 13.4137 10.9239 13 9.3578 13C6.29037 13 0 14.9844 0 18.9516V22H10.3211V20.8336C10.3211 19.4546 10.8716 18.0719 11.8349 16.9194C12.6034 15.999 13.6796 15.1448 15 14.4516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14C18.9953 14 12 16.2333 12 20.6667V24H33V20.6667C33 16.2333 26.0047 14 22.5 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C25.3137 12 28 9.31371 28 6C28 2.68629 25.3137 0 22 0C18.6863 0 16 2.68629 16 6C16 9.31371 18.6863 12 22 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.91fd1699a3a4f754f40edcbce10d3871.svg";
export { ForwardRef as ReactComponent };